import { render, staticRenderFns } from "./TrashFilter.vue?vue&type=template&id=48c7366e"
import script from "./TrashFilter.vue?vue&type=script&lang=js"
export * from "./TrashFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports